export const MAIN_ROUTES = {
    MAIN: '/main',
    REGISTRATION_CUSTOMER: '/registration/customer',
    REGISTRATION_CLEANER: '/registration/cleaner',
    LOGIN: '/login',
    FORGOT_PASSWORD_STEP_1: '/restore-password-step-1',
    FORGOT_PASSWORD_STEP_2: '/restore-password-step-2',
    FORGOT_PASSWORD_STEP_3: '/restore-password-step-3',
    FORGOT_PASSWORD_STEP_4: '/restore-password-step-4',
    CREATE_ORDER: '/create-order',
    CREATE_ORDER_STEP_1: '/create-order/step-1',
    CREATE_ORDER_STEP_2: '/create-order/step-2',
    CREATE_ORDER_STEP_3: '/create-order/step-3',
    CREATE_ORDER_STEP_4: '/create-order/step-4',
    CREATE_ORDER_STEP_5: '/create-order/step-5',
    SETTINGS: '/settings',
    PAYMENT: '/payment',
    ORDER_DETAILS: '/order-details',
    ALL_CLEANING_REQUESTS: '/all-cleaning-requests',
    APPLY_FOR_ORDER: '/cleaning-request',
    // ACCEPT_ORDER: '/offer',
    COMPLETED_ORDERS: '/completed-orders',
    FEEDBACK: '/feedback',
    ACTIVE_ORDER: '/order',
    // OFFERS: '/offers',
    ORDERS: '/orders',
    CLEANER_APPLICATIONS: '/cleaner-applications',
    CLEANER_APPLICATION: '/cleaner-application',
    SUPPORT: '/support',
    SUPPORT_CHAT: '/support/chat',
}
